<template>
  <el-button class="code-btn" @click="clickHandler">
    <span class="off" v-if="disabled">{{ sec }}S</span>
    <span class="on" v-else>{{ defaultText }}</span>
  </el-button>
</template>

<script>
export default {
  name: 'CountDown',
  props: {
    second: {
      type: Number,
      default: 60,
    },
    defaultText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      disabled: false,
      timerId: null,
      sec: this.second,
    };
  },
  methods: {
    clickHandler() {
      if (this.disabled) return;

      this.$emit('click', () => {
        this.disabled = true;
        setTimeout(() => this.startCountDown(), 1000);
      });
    },
    startCountDown() {
      this.sec--;
      if (this.sec <= 0) {
        this.disabled = false;
        this.sec = this.second;

        clearTimeout(this.timerId);
      } else {
        this.timerId = setTimeout(() => this.startCountDown(), 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.code-btn {
  min-width: 110px;
}
.on {
  color: #fd9b21;
}
.off {
  color: #999;
}
</style>
